import * as React from "react";
import { View, DisplayMode } from "../../../../api/api";
import { APINames } from "../../../../legacy/api/api.names";
import {
  BetButton,
  BetButtonWrapperForMobile
} from "../../../../v2/components/BetButton";
import { FreeRoundsDisplayMobile } from "../../../../v2/components/Display/mobile/FreeRounds";
import { FreeSpinsDisplayMobile } from "../../../../v2/components/Display/mobile/FreeSpins";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";

import { FooterMobile } from "../../Footer";

import {
  DisplayWrapperPortrait,
  DisplayWrapperLandscape
} from "../../../../v2/components/Display/mobile/Display";
import {
  KeypadButtonContainer,
  StyledCombinedSpinButton,
  StyledKeypadButton
} from "./components/Buttons";
import { Controls } from "./components/Controls";
import {
  BottomPanel,
  DisplaysWrapper,
  GameArea,
  KeypadWrapper,
  SpinButtonWrapper
} from "./components/Wrappers";
import { IKeypadMobile } from "./KeypadMobile";
import { BetDisplayMobile } from "../../../../v2/components/Display/mobile/Bet";
import { WinDisplayMobile } from "../../../../v2/components/Display/mobile/Win";
import { TotalWinDisplayMobile } from "../../../../v2/components/Display/mobile/TotalWin";
import { BalanceDisplayMobile } from "../../../../v2/components/Display/mobile/Balance";

export const KeypadMobileDefaultViewInternal = ({
  hidden,
  muted,
  autoplayAvailable,
  quickSpinActive,
  quickSpinAvailable,
  quickSpinEnabled,
  autoplayRoundsSelected,
  autoplayRoundsLeft,
  autoplayRunning,
  autoplayButtonDisabled,
  isFreeRoundsEnabled,
  isFreeSpinsEnabled,
  spinStarted,

  menuButtonDisabled,
  soundButtonDisabled,
  spinButtonDisabled,
  isFullscreenGame,
  isLeftHandMode,
  isTickerHidden,
  triggerAutoplaySettingsViewChangeRequest,
  triggerQuickSpinChangeRequest,
  triggerGameRulesViewChangeRequest,
  triggerMuteChangeRequest,

  view,
  displayMode
}: IKeypadMobile) => {
  const shouldHideControlsAndGameArea = view === null || view !== View.DEFAULT;
  const isMinimalUI = displayMode === DisplayMode.MINIMAL;

  const soundButton = (
    <StyledKeypadButton
      apiName={APINames.SOUND_BUTTON}
      data-e2e-id={E2EIdentifier.MOBILE_KEYPAD_MUTE_BUTTON}
      type="sound"
      active={!muted}
      onClick={triggerMuteChangeRequest(!muted)}
      disabled={soundButtonDisabled}
    />
  );

  const menuButton = (
    <StyledKeypadButton
      apiName={APINames.MENU_BUTTON}
      data-e2e-id={E2EIdentifier.MOBILE_KEYPAD_MENU_BUTTON}
      type="menu"
      onClick={!menuButtonDisabled && triggerGameRulesViewChangeRequest}
      disabled={menuButtonDisabled}
    />
  );

  const quickSpinButton = (
    <StyledKeypadButton
      data-e2e-id={E2EIdentifier.MOBILE_KEYPAD_QUICKSPIN_BUTTON}
      apiName={APINames.QUICKSPIN_BUTTON}
      type="quickspin"
      onClick={
        quickSpinEnabled && triggerQuickSpinChangeRequest(!quickSpinActive)
      }
      disabled={!quickSpinEnabled}
      active={quickSpinActive}
    />
  );

  const autoplayButton = (
    <StyledKeypadButton
      data-e2e-id={E2EIdentifier.MOBILE_KEYPAD_AUTOPLAY_BUTTON}
      visible={autoplayAvailable}
      apiName={APINames.AUTOPLAY_BUTTON}
      type="autoplay"
      onClick={
        !autoplayButtonDisabled && triggerAutoplaySettingsViewChangeRequest
      }
      disabled={autoplayButtonDisabled}
    />
  );

  return (
    <>
      {shouldHideControlsAndGameArea ? null : <GameArea />}
      <KeypadWrapper hidden={hidden}>
        {shouldHideControlsAndGameArea ? null : (
          <Controls
            useFullscreen={isFullscreenGame}
            isMinimalUI={isMinimalUI}
            autoplayRunning={autoplayRunning}
            isLeftHandMode={isLeftHandMode}
            isTickerHidden={isTickerHidden}
          >
            <KeypadButtonContainer>{soundButton}</KeypadButtonContainer>
            <KeypadButtonContainer>
              <BetButtonWrapperForMobile>
                <BetButton />
              </BetButtonWrapperForMobile>
            </KeypadButtonContainer>
            <KeypadButtonContainer>
              <SpinButtonWrapper>
                <StyledCombinedSpinButton
                  hidden={isMinimalUI && !autoplayRunning}
                  disabled={spinButtonDisabled}
                  autoplayActive={
                    autoplayRoundsSelected > 0 || autoplayRoundsLeft > 0
                  }
                  autoplayRoundsLeft={autoplayRoundsLeft}
                  autoplayRunning={autoplayRunning}
                  spinStarted={spinStarted}
                />
              </SpinButtonWrapper>
            </KeypadButtonContainer>
            <KeypadButtonContainer>
              {autoplayAvailable && autoplayButton}
              {!autoplayAvailable && quickSpinAvailable && quickSpinButton}
            </KeypadButtonContainer>
            <KeypadButtonContainer>{menuButton}</KeypadButtonContainer>
          </Controls>
        )}
        <BottomPanel>
          <DisplayWrapperPortrait>
            {isFreeSpinsEnabled && <FreeSpinsDisplayMobile />}
            {isFreeRoundsEnabled && <FreeRoundsDisplayMobile />}
          </DisplayWrapperPortrait>
          <DisplaysWrapper>
            {isFreeSpinsEnabled && (
              <DisplayWrapperLandscape>
                <FreeSpinsDisplayMobile />
              </DisplayWrapperLandscape>
            )}
            <WinDisplayMobile />

            <BetDisplayMobile />

            {isFreeRoundsEnabled ? (
              <TotalWinDisplayMobile />
            ) : (
              <BalanceDisplayMobile />
            )}

            {isFreeRoundsEnabled && (
              <DisplayWrapperLandscape>
                <FreeRoundsDisplayMobile />
              </DisplayWrapperLandscape>
            )}
          </DisplaysWrapper>
          <FooterMobile />
        </BottomPanel>
      </KeypadWrapper>
    </>
  );
};

export const KeypadMobileDefaultView = (props: IKeypadMobile) => (
  <KeypadMobileDefaultViewInternal {...props} />
);
